import { IBaseBlockShowResource, RenderView } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextPage } from "./TextPage";

export const RegistrationClosedPage: FC<{ block: IBaseBlockShowResource | null }> = ({ block }) => {
	const { t } = useTranslation();
	if (block) {
		return <RenderView block={block} />;
	}

	return <TextPage headline={t("Closed registration")} text={t("This registration is closed.")} />;
};
